// removed by extract-text-webpack-plugin
module.exports = {"collections":"_1eLzH","header":"_34utG","list":"_3gGbp"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/CollectionsList/index.sass
// module id = 1473
// module chunks = 1